//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from './Input';

export default {
    extends: Input,

    props: {
        noAuto: Boolean,
    },

    data() {
        return {
            isObscured: true,
        };
    },
};
